<template>
    <div>
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl dc">更换手机</span>
        </div>
        <div class="progress-box">
            <div :class="`progress${first ? ' steps-active' : ''}`">
                <i class="steps-icon">1</i>
                <span class="steps-text">验证身份</span>
                <i class="steps-line"></i>
            </div>

            <div :class="`progress${!first ? ' steps-active' : ''}`">
                <i class="steps-icon">2</i>
                <span class="steps-text">绑定手机</span>
                <i class="steps-line"></i>
            </div>

            <div class="progress">
                <i class="steps-icon">3</i>
                <span class="steps-text">绑定成功</span>
                <i class="steps-line steps-opacity"></i>
            </div>
        </div>

        <div class="form" v-if="first" @keyup.enter="next">
            <div class="form-group old-box cn cb">
                <div class="old-title fl">原手机号</div>
                <div :class="`old-phone fl${phoneTip ? ' ol' : ''}`">{{$store.state.user.phone}}</div>
            </div>
            <div class="form-message"></div>

           <!-- <div class="form-group code-box">
                <input v-model="captcha" @focus="cpcTip = ''" :class="`code${cpcTip ? ' ol' : ''}`" maxlength="4" type="text" placeholder="图片验证码">
                <img class="cp" @click="captchaSrc += '?'" :src="captchaSrc">
            </div>-->

            <!--<div class="form-message">{{cpcTip}}</div>-->

            <div class="form-group code-box">
                <input v-model="code" @focus="codeTip = ''" :class="`code${codeTip ? ' ol' : ''}`" maxlength="6" type="text" placeholder="短信验证码">
                <input type="text" name="hidden" class="input-hidden">
                <div :class="`button ${cooldown ? 'disabled' : 'bg'}`">
                    <span v-show="is_sending && !cooldown" class="send-btn loading">&nbsp;</span>
                    <span v-show="!is_sending" @click="send" class="send-btn">{{`${cooldown ? '' : '点击'}${is_first_code ? '' : '重新'}获取${cooldown ? `(${cooldown}s)` : ''}`}}</span>
                </div>
            </div>

            <div class="form-message">{{codeTip}}</div>

            <div class="form-group bg next cp" @click="next">
                <span v-show="!is_loading">下一步</span>
                <span v-show="is_loading" class="next-box loading"></span>
            </div>
            <!--<div v-show="is_loading" class="form-group bg next cp " ></div>-->
        </div>

        <div class="form" v-if="!first" @keyup.enter="update">
            <div class="form-group old-box cb">
                <!--<div class="old-title fl">新手机号</div>-->
                <el-select class="old-title fl" filterable v-model="nation" placeholder="请选择">
                    <el-option v-for="(v, k) in countries" :key="k" :label="`${v.name} ${v.alias} +${v.code}`" :value="v.code">
                        <span class="fl">{{v.name}}</span>
                        <span class="sign-select-option fl">{{v.alias}}</span>
                        <span class="sign-select-option fl">+{{v.code}}</span>
                    </el-option>
                </el-select>
                <input v-model="phone" @focus="phoneTip = ''" :class="`old-phone new-phone fl${phoneTip ? ' ol' : ''}`" type="text" maxlength="11" placeholder="请输入新手机号">
                <input type="text" name="hidden" class="input-hidden">
            </div>
            <div class="form-message">{{phoneTip}}</div>

            <div class="form-group code-box">
                <input v-model="captcha" @focus="cpcTip = ''" :class="`code${cpcTip ? ' ol' : ''}`" maxlength="4" type="text" placeholder="图片验证码">
                <input type="text" name="hidden" class="input-hidden">
                <img class="cp" @click="captchaSrc += '?'" :src="captchaSrc" alt="code">
            </div>
            <div class="form-message">{{cpcTip}}</div>

            <div class="form-group code-box">
                <input v-model="code" @focus="codeTip = ''" :class="`code${codeTip ? ' ol' : ''}`" maxlength="6" type="text" placeholder="短信验证码">
                <input type="text" name="hidden" class="input-hidden">
                <div :class="`button ${cooldown ? 'disabled' : 'bg'}`">
                    <span v-show="is_sending && !cooldown" class="send-btn loading">&nbsp;</span>
                    <span v-show="!is_sending" @click="sendNew" class="send-btn">{{`${cooldown ? '' : '点击'}${is_first_code ? '' : '重新'}获取${cooldown ? `(${cooldown}s)` : ''}`}}</span>
                </div>
            </div>
            <div class="form-message">{{codeTip}}</div>
            <div class="form-group bg next cp" @click="update">
                <span v-show="!is_loading">立即绑定</span>
                <span v-show="is_loading" class="next-box loading"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            first: true,// 是否为第一步
            is_loading: false,
            is_sending: false,
            captcha: '',
            code: '',
            cpcTip: '',
            codeTip: '',
            captchaSrc: '',
            cooldown: 0,// 倒计时
            timer: 0,// 定时器 因为有2个模块都需要使用 所以需要保存
            is_first_code: true,// 是否为第一次获取code
            oldCode: '',// 将旧手机验证码暂存
            token: '',// 将旧手机验证码获得的token暂存 在绑定手机时一起发送给后端进行验证
            nation: '86',// 新手机号的区号
            phone: '',// 新手机号
            phoneTip: '',
        }),
        methods: {
            checkCpc() {
                if (this.captcha.length !== 4 || !/^[A-Za-z0-9]*$/.test(this.captcha)) {
                    this.cpcTip = '请输入正确的验证码';
                }
            },
            checkCode() {
                if (this.code.length !== 6 || isNaN(+this.code)) {
                    this.codeTip = '请输入正确的短信验证码';
                }
            },
            checkPhone() {
                if(isNaN(+this.phone) || this.phone.length < 6 || this.phone.length > 11) {
                    this.phoneTip = '请输入正确的手机号';
                    return false;
                }
            },
            error(e) {
                if (!e) return;
                let {status_code, message} = e;
                switch (status_code) {
                    case 1001: this.phoneTip = message;break;
                    case 1002: this.nicoTip = message;break;
                    case 1003: this.pswTip = message;break;
                    case 1004:
                        this.cpcTip = message;
                        this.captchaSrc += '?';
                        this.captcha = '';
                        break;
                    case 1005: this.codeTip = message;break;
                    case 1007:
                        this.alert.err(message);
                        this.first = true;
                        break;
                    default:
                        this.alert.err(message);
                }
                this.is_sending = this.is_loading = false;// 取消发送验证码按钮的loading
            },
            send() {// 向旧手机发送验证码
                // this.checkCpc();
                if (this.is_sending || this.cooldown) return;

                this.is_sending = true;

                this.api.get(`users/send`).then(() => {
                    this.is_first_code = this.is_sending = false;
                    this.cooldown = 60;// 发送成功 进入冷却时间60s
                    this.timer = setInterval(() => this.cooldown ? this.cooldown-- : clearInterval(this.timer), 1000);
                }, this.error);
            },
            next() {// 下一步
                this.checkCode();

                if (this.codeTip || this.is_loading) return;

                this.is_loading = true;

                this.api.get('users/check', {code: this.code}).then(e => {
                    this.first = this.is_loading = false;// 进入下一步
                    this.token = e.token;
                    this.oldCode = this.code;
                    this.code = '';
                    this.is_first_code = true;
                    clearInterval(this.timer);
                    this.cooldown = 0;
                }, this.error);
            },
            sendNew() {// 向新手机发送验证码
                this.checkPhone();
                this.checkCpc();
                if (this.phoneTip || this.cpcTip || this.is_sending || this.cooldown) return;

                this.is_sending = true;

                this.api.get('sign/msg', {code: this.captcha, nation: this.nation, phone: this.phone}).then(() => {
                    this.is_first_code = this.is_sending = false;
                    this.cooldown = 60;// 发送成功 进入冷却时间60s
                    this.timer = setInterval(() => this.cooldown ? this.cooldown-- : clearInterval(this.timer), 1000);
                }, this.error);
            },
            update() {// 绑定手机
                this.checkPhone();
                this.checkCode();

                if (this.phoneTip || this.codeTip || this.is_loading) return;

                this.is_loading = true;

                this.api.post('users/phone/update', {
                    nation: this.nation,// 新手机号区号
                    phone: this.phone,// 新手机号
                    code: this.code,// 新验证码
                    oldCode: this.oldCode,// 旧手机号
                    oldToken: this.token,// 旧手机token
                }).then(() => {
                    this.user.phone = `${this.phone.substr(0, 3)}****${this.phone.substr(7)}`;
                    window.localStorage.user = this.user;
                    this.alert.suc('更换成功');
                    this.$router.push('/user');
                }, this.error);
            },
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
            countries() {
                return this.$store.state.countries;
            },
        },
        watch: {
            phone (e) {
                this.phoneTip = '';
                if (e.length === 11) {
                    this.api.get(`sign/phone/check/${e}`).then(() => {

                    }, e => {
                        if (e.status_code  === 1001) {
                            this.phoneTip = e.message;
                        }
                    })
                }
            },
        },
        created() {
            this.captchaSrc = this.api.captchaImgHost;
        },
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/mod-phone.css";
</style>



// WEBPACK FOOTER //
// src/views/user/ModPhone.vue